import { Box, Typography } from '@material-ui/core';
import React, { Children, cloneElement, FC, isValidElement, ReactElement } from 'react';
import hoverStyle from 'styles/hover-overlay.module.scss';
import { ObjectPermissionSetData } from 'types/permissions';
import { findPermissionByName } from 'utils/permissions';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

export interface PermissionsControlProps {
 permissions: ObjectPermissionSetData[];
 builderType: string;
 readonlyForChangablePro?: boolean;
}

export const PermissionsControl: FC<PermissionsControlProps> = ({ permissions, builderType, readonlyForChangablePro,children }) => {

 //grant read only permission for pro type if the changable is false
 const readonlyForPro = !findPermissionByName(permissions, 'changeable')?.objectPermissionValue && builderType === "PRO" && readonlyForChangablePro;

 const isChangeable = findPermissionByName(permissions, 'changeable')?.objectPermissionValue || builderType !== 'PRO' || readonlyForPro;
 const isVisible = findPermissionByName(permissions, 'visible')?.objectPermissionValue;
 const enableMouseEvents = isChangeable && isVisible;

 return (
  <Box className={hoverStyle.root} style={{ pointerEvents: enableMouseEvents ? 'unset' : 'none' }}>
   {!isVisible && (
    <Box className={hoverStyle.root_content} style={{ visibility: 'visible', opacity: 1 }}>
     <Typography variant='subtitle2' className='d-flex aling-items_center' color='textSecondary'>
      <VisibilityOffIcon fontSize='small' /> <b>Not visible</b>
     </Typography>
    </Box>
   )}
   {Children.map(children, child => {
    if(isValidElement(child)) {
        return cloneElement(child as ReactElement<any>, readonlyForPro? { readonly : true}: {})
    }

    return child;
   })}
  </Box>
 );
};
